
export const filterOptions = (val , options, maxLines=999) => {
    if (val) {
      return options.filter(
          (item) =>
            item.label.toUpperCase().includes(val.toUpperCase()) ||
            item.value.toUpperCase().startsWith(val.toUpperCase())
        )
        .slice(0, maxLines);
    }
    return options.slice(0, maxLines);
  };

export  const findOptionByValue = (val, options) => {
  if(options.length && val){
    return options.find(item => item.value === val)
  }
  return {value: val, label:""};
}

export const defaultIfNullOrUndefined = (value, defaultValue) => {
  return value == null ? defaultValue : value;
}

export const isAlphaNumericOnly = (value) => {
  return /^[a-zA-Z0-9]+$/.test(value)
}

export const filterGenderOptions = (val , options, maxLines=999) => {
  if (val) {
    return options.filter(
        (item) =>
          item.label.toUpperCase().includes(val.toUpperCase()) //||
          //item.value.toUpperCase().startsWith(val.toUpperCase())
      )
      .slice(0, maxLines);
  }
  return options.slice(0, maxLines);
};